import * as redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/do'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/mapTo'
import * as Flash from '../../components/flash-message'
import * as Form from '../../components/form'
import * as Menu from '../../components/menu'
import * as Request from '../../request'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'

const onSubmit = (action$: ReduxObservable.ActionsObservable<Form.SaveAction<Types.FormFields>>) =>
  action$.ofType(Actions.FormConstants[Form.SAVE])
    .map((action) => Actions.forgotPasswordSubmit(action.value))

const handleForgotPassword = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: redux.Store<any>,
) => action$.ofType(Request.successConstant(Constants.FORGOT_PASSWORD))
  .map(() => Router.push(`${Menu.AUTH_FORGOT_PASSWORD_SUCCESS_URL}`))

const handleForgotPasswordError = (
  action$: ReduxObservable.ActionsObservable<any>,
) => action$.ofType(Request.errorConstant(Constants.FORGOT_PASSWORD))
  .map((errorResponse) => Flash.showFlashError('Error: ' + errorResponse.payload.error.response.message))

export const epic = ReduxObservable.combineEpics(
  handleForgotPassword,
  handleForgotPasswordError,
  onSubmit,
)



// WEBPACK FOOTER //
// ./src/pages/forgot-password/epic.ts